export const getMajorAssemblyApi = (params) => {
    return `console/${params?.leaseSlug}/major-assembly`;
}
export const getConsantApi = () => {
    return `lease/constants/get_by_constant_types`;
}
export const getRentalFundReportApi = (queryParam, query) => {
    const queryString = new URLSearchParams(query).toString();
    return queryParam?.account_type ? `/invoices/${queryParam?.lease_slug}/rental-reports?as_of_date=${queryParam?.as_of_date}&account_type=${queryParam?.account_type}&asset_id=${queryParam?.asset_id}&asset_type=${queryParam?.asset_type}&${queryString ? `${queryString}` : ""}` : `/invoices/${queryParam?.lease_slug}/rental-reports?as_of_date=${queryParam?.as_of_date}&asset_id=${queryParam?.asset_id}&asset_type=${queryParam?.asset_type}&${queryString ? `${queryString}` : ""}`;
};
export const getRentalFundBalanceApi = (queryParam, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/invoices/${queryParam?.lease_slug}/rental-reports-cards?as_of_date=${queryParam?.as_of_date}${queryString ? `&${queryString}` : ""}`;
}
export const getRentalCurrencyApi = (queryParam) => {
    const queryString = new URLSearchParams(queryParam).toString();
    return `/invoices/currency?${queryString}`;
}
